export type Theme = "light" | "dark";

const STORAGE_KEY = "mobsuccess.auth.theme";

function isTheme(value: unknown): value is Theme {
  return value === "light" || value === "dark";
}

// The visitor's explicit choice, or null while the app follows the system.
export function readStoredTheme(): Theme | null {
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    return isTheme(value) ? value : null;
  } catch {
    return null;
  }
}

export function getSystemTheme(): Theme {
  return window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
}

// `data-theme` on <html> is what mobyone.css keys its Midnight roles on; with
// no attribute the stylesheet follows the system setting.
export function applyTheme(theme: Theme | null): void {
  if (theme === null) {
    delete document.documentElement.dataset.theme;
  } else {
    document.documentElement.dataset.theme = theme;
  }
}

export function storeTheme(theme: Theme): void {
  applyTheme(theme);
  try {
    window.localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    // Storage unavailable: the choice holds for this page only.
  }
}
